import { useResetAtom } from 'jotai/utils';
import { createIntegrationAtom, editIntegrationAtom } from './atoms';

export const useResetPanelAtoms = () => {
  const resetCreateFormAtom = useResetAtom(createIntegrationAtom);
  const resetEditFormAtom = useResetAtom(editIntegrationAtom);

  const reset = () => {
    resetCreateFormAtom();
    resetEditFormAtom();
  };

  return {
    reset,
    resetCreateFormAtom,
    resetEditFormAtom,
  };
};
